import React, { useState } from 'react';
import API from '../../api/api';
import Modal from './Modal';
import { Button, Input } from '../ui';

interface AddUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (username: string, userID: number) => Promise<void>;
}

const AddUserModal: React.FC<AddUserModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const [username, setUsername] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    const trimmed = username.trim().replace(/^@/, '');
    if (!trimmed) {
      setErrorMessage('Username is required.');
      return;
    }

    try {
      setIsSubmitting(true);
      const resolved = await API.resolveTelegramUsername(trimmed);
      await onSubmit(trimmed, resolved.user_id);
      setUsername('');
      onClose();
    } catch (error: any) {
      const msg =
        error?.response?.data?.error ||
        (error instanceof Error ? error.message : '') ||
        'Failed to resolve username';
      setErrorMessage(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add User" size="sm">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-slate-300 text-xs uppercase tracking-wide mb-1">Telegram Username</label>
          <Input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="@username"
          />
          <p className="text-slate-500 text-xs mt-1">Must be configured in ALLOWED_USER_IDS on the server.</p>
        </div>

        <div className="flex gap-2 pt-2">
          <Button type="button" variant="secondary" className="flex-1" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="flex-1"
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Resolving...' : 'Add User'}
          </Button>
        </div>
        {errorMessage && <p className="text-xs text-danger">{errorMessage}</p>}
      </form>
    </Modal>
  );
};

export default AddUserModal;
